import type { MessageKey } from "./ru"

export const idMessages = {
  "common.loading": "Memuat...",
  "common.error": "Kesalahan",
  "common.back": "Kembali",
  "common.next": "Lanjut",
  "common.search": "Cari",
  "auth.loginErrorTitle": "Kesalahan masuk",
  "auth.openViaTelegram": "Buka aplikasi melalui Telegram",
  "auth.telegramRequired": "Aplikasi harus dibuka melalui Telegram",
  "auth.authorizationError": "Kesalahan otorisasi",
  "device.rotatePortrait": "Putar perangkat ke posisi vertikal",
  "country.brazil": "Brasil",
  "country.vietnam": "Vietnam",
  "country.egypt": "Mesir",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Spanyol",
  "country.italy": "Italia",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Kolombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Meksiko",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Rusia",
  "country.usa": "Amerika Serikat",
  "country.turkey": "Turki",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraina",
  "country.philippines": "Filipina",
  "countrySelection.chooseCountry": "Pilih negara",
  "countrySelection.openAria": "Pilih negara",
  "languageSelection.chooseLanguage": "Pilih bahasa",
  "commercial.direction.autotrade": "Pasar Otomotif",
  "commercial.direction.insurance": "Asuransi",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Bantuan Jalan",
  "commercial.searchLabel": "Pencarian BeepApp",
  "commercial.cityPlaceholder": "Masukkan kota",
  "commercial.emptyTitle": "Belum ada penawaran hari ini",
  "commercial.emptyLine1": "Belum ada mitra BeepApp aktif di kota Anda",
  "commercial.emptyLine2": "Kami sedang mencari dan menghubungkan mitra baru",
  "commercial.emptyLine3": "Penawaran baru akan muncul di sini secara otomatis",
  "commercial.helperLine1": "Masukkan kota untuk melihat",
  "commercial.helperLine2": "penawaran yang tersedia",
  "commercial.partnerPrompt": "Ingin menjadi mitra BeepApp?",
  "commercial.apply": "Ajukan permohonan",
  "main.admin": "Admin",
  "main.garage": "Garasi",
  "main.signalSent": "Sinyal terkirim",
  "main.partnerInviteUnavailable": "Undangan mitra tidak tersedia",
  "main.enterPlate": "Masukkan nomor kendaraan",
  "main.searchError": "Kesalahan pencarian",
  "main.signalSendError": "Gagal mengirim sinyal",
  "main.shareCardPrefix": "Kartu nomor kendaraan",
  "main.shareLinkError": "Tautan tidak dapat disiapkan",
  "main.searchByPlateAria": "Cari berdasarkan nomor kendaraan",
  "main.russianPlateAria": "Nomor kendaraan Rusia",
  "main.plateAria": "Nomor kendaraan",
  "main.findPlateAria": "Cari nomor",
  "main.loadingVehicle": "Memuat kartu kendaraan…",
  "main.leaveSignal": "Kirim sinyal",
  "main.share": "Bagikan",
  "signalSelection.chooseType": "Pilih jenis sinyal",
  "signalSelection.category.attention": "Pribadi",
  "signalSelection.category.road": "Jalan",
  "signalSelection.category.urgent": "Darurat",
  "signalSelection.chooseSignal": "Pilih sinyal",
  "signalSelection.suggestOwn": "Usulkan pilihan Anda",
  "signalConfirmation.title": "Konfirmasi sinyal",
  "signalConfirmation.plateHeading": "Periksa nomor kendaraan",
  "signalConfirmation.signalHeading": "Periksa sinyal yang dipilih",
  "signalConfirmation.replyTitle": "Izinkan balasan di Telegram",
  "signalConfirmation.replyBody": "Aktifkan agar pemilik nomor dapat\nmenghubungi Anda di Telegram. Balasan hanya mungkin jika\nAnda memiliki @username. Keputusan untuk membalas tetap\nberada pada pemilik nomor.",
  "signalConfirmation.consentText": "Saya mengonfirmasi bahwa sinyal ini sesuai\ndengan situasi nyata dan bukan spam\natau laporan palsu.",
  "signalConfirmation.warning": "Setelah dikirim, sinyal\ntidak dapat diubah",
  "signalConfirmation.sending": "Mengirim…",
  "signalConfirmation.send": "Kirim",
  "partner.loadingAria": "Memuat",
  "partner.title": "Program Mitra",
  "partner.offerLine1": "Dapatkan 30% tanpa batas waktu dari semua pembayaran",
  "partner.offerLine2": "pengguna yang Anda undang ke BeepApp",
  "partner.offerLine3": "melalui program afiliasi Telegram",
  "partner.connectUnavailable": "Koneksi akan tersedia setelah program Afiliasi Telegram dikonfigurasi.",
  "partner.connectTelegram": "Hubungkan di Telegram",
  "partner.qrAria": "Kode QR tautan mitra",
  "partner.download": "Unduh",
  "partner.promoHeading": "Buat kode promo pribadi",
  "partner.promoHelperLine1": "Kode promo mengaktifkan tambahan satu tahun langganan",
  "partner.promoHelperLine2": "dan membantu menarik pengguna",
  "partner.promoAria": "Kode promo",
  "partner.affiliateHeading": "Tautan afiliasi Anda",
  "partner.affiliateHelper": "Simpan tautan untuk membuat kode QR pribadi",
  "partner.affiliateAria": "Tautan afiliasi",
  "partner.qrNoteLine1": "Kode QR dapat ditempatkan pada kendaraan,",
  "partner.qrNoteLine2": "di media sosial dan materi iklan",
  "partner.save": "Simpan",
  "partner.reset": "Reset",
  "partner.resetConfirm": "Reset tautan afiliasi yang tersimpan? Kode promo tetap menjadi milik Anda.",
  "partner.promoFormatError": "Kode promo harus berisi 4 hingga 15 karakter.",
  "partner.affiliateHostError": "Hanya tautan t.me atau telegram.me yang diizinkan.",
  "partner.affiliatePathError": "Tautan tidak memiliki jalur Telegram.",
  "partner.affiliateFormatError": "Tautan afiliasi tidak valid.",
  "partner.loadError": "Kesalahan memuat",
  "partner.checkInputError": "Periksa data yang dimasukkan",
  "garageActivation.promoInvalid": "Kode promo tidak valid",
  "garageActivation.plateOccupied": "Nomor kendaraan ini sudah ditautkan",
  "garageActivation.activateError": "Garasi tidak dapat diaktifkan",
  "garageEntry.loadJournalError": "Buku catatan tidak dapat dimuat",
  "garageEntry.loadStatusesError": "Status tidak dapat dimuat",
  "garageEntry.activationSuccess": "Garasi berhasil diaktifkan",
  "garageEntry.plateAttached": "Nomor berhasil ditautkan",
  "garageEntry.attachError": "Nomor tidak dapat ditautkan",
  "garageEntry.activationNote": "Aktifkan Garasi Anda",
  "garageSheet.activationTitle": "Aktivasi Garasi",
  "garageSheet.plateHelper": "Masukkan nomor kendaraan",
  "garageSheet.promoHelper": "Punya kode promo?",
  "garageSheet.cleanBonusLine1": "Setelah aktivasi, Anda punya 1 jam",
  "garageSheet.cleanBonusLine2": "untuk “Mulai Bersih” gratis",
  "garageSheet.activationFor": "Aktivasi selama",
  "garageSheet.cost": "Biaya",
  "garageSheet.ownerConsentLine1": "Saya mengonfirmasi bahwa saya pemilik",
  "garageSheet.ownerConsentLine2": "kendaraan dengan nomor registrasi",
  "garageSheet.ownerConsentLine3": "yang tercantum.",
  "garageSheet.processing": "Memproses...",
  "garageSheet.attach": "Tautkan",
  "garageSheet.pay": "Bayar",
  "garageLifecycle.cleanTitle": "Mulai Bersih",
  "garageLifecycle.deactivateTitle": "Nonaktifkan Garasi",
  "garageLifecycle.cleanWarningLine1": "Riwayat nomor akan dihapus",
  "garageLifecycle.cleanWarningLine2": "dan tidak dapat dipulihkan!",
  "garageLifecycle.deactivateWarningLine1": "Setelah dinonaktifkan, akses ke fitur",
  "garageLifecycle.deactivateWarningLine2": "Garasi aktif akan dihentikan",
  "garageLifecycle.willBeDeleted": "AKAN DIHAPUS",
  "garageLifecycle.cleanRemovedLine1": "• Semua entri dari Buku Catatan",
  "garageLifecycle.cleanRemovedLine2": "• Riwayat sinyal yang diterima",
  "garageLifecycle.cleanRemovedLine3": "• Penghitung sinyal publik",
  "garageLifecycle.cleanRemovedLine4": "  pada kartu nomor kendaraan",
  "garageLifecycle.willRemain": "AKAN TETAP ADA",
  "garageLifecycle.cleanPreservedLine1": "• Tautan nomor ke Garasi",
  "garageLifecycle.cleanPreservedLine2": "• Sisa masa aktivasi",
  "garageLifecycle.cleanPreservedLine3": "• Status nomor yang dipilih",
  "garageLifecycle.cleanPreservedLine4": "• Total jumlah tampilan kartu nomor",
  "garageLifecycle.freeFirstHour": "Gratis pada jam pertama",
  "garageLifecycle.willBecomeUnavailable": "AKAN TIDAK TERSEDIA",
  "garageLifecycle.deactivateRemovedLine1": "• Buku Catatan",
  "garageLifecycle.deactivateRemovedLine2": "• Memilih dan menggunakan status nomor",
  "garageLifecycle.deactivateRemovedLine3": "• Anda otomatis keluar dari AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Pasar Otomotif",
  "garageLifecycle.deactivateRemovedLine5": "• Asuransi",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Bantuan Jalan",
  "garageLifecycle.deactivateRemovedLine8": "• Nomor kendaraan akan dilepas dari Garasi",
  "garageLifecycle.willRemainAvailable": "AKAN TETAP TERSEDIA",
  "garageLifecycle.deactivatePreservedLine1": "• Teman Perjalanan",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Pencarian nomor kendaraan dan melihat",
  "garageLifecycle.deactivatePreservedLine4": "  kartu kendaraan publik",
  "garageLifecycle.deactivatePreservedLine5": "• Kemampuan untuk mengaktifkan kembali",
  "garageLifecycle.deactivatePreservedLine6": "  Garasi kapan saja",
  "garageLifecycle.cleanConsentLine1": "Saya menyetujui penghapusan",
  "garageLifecycle.cleanConsentLine2": "seluruh riwayat nomor ini",
  "garageLifecycle.cleanConsentLine3": "tanpa kemungkinan pemulihan.",
  "garageLifecycle.deactivateConsentLine1": "Saya mengonfirmasi penonaktifan dan",
  "garageLifecycle.deactivateConsentLine2": "penghentian akses ke seluruh",
  "garageLifecycle.deactivateConsentLine3": "fitur Garasi aktif.",
  "garageLifecycle.clean": "Bersihkan",
  "garageLifecycle.deactivate": "Nonaktifkan",
} satisfies Record<MessageKey, string>
